import React, { useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Card, CardContent, useMediaQuery } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import { Pagination, useGlobal } from '@rcg/ui-react';
import { formatPrice } from '@rcg/pricing-format';
import useStyles from './useStyles';
import { filteredResultsVar } from '../../operations/localState/reactiveVariables';
import FlightInformation from './components/FlightInformation';
import FlightExpanded from './components/FlightExpanded';
import Dictionary from '../../utils/dictionary';
import Theme from '../../utils/theme';
import { FLIGHT_TYPE_CODES } from '../../utils/constants';

const ResultsCard = ({ flightType }) => {
  const classes = useStyles();
  const { renderContent } = useGlobal();
  const [expanded, setExpanded] = React.useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const filteredResults = useReactiveVar(filteredResultsVar);
  const isSm = useMediaQuery(Theme.breakpoints.down('sm'));

  const handleExpandClick = (index) => {
    const cardStates = [...expanded];
    cardStates[index] = !expanded[index];
    setExpanded(cardStates);
  };

  const onChangePage = (data) => {
    const paginatedItems = data.paginatedItems.length ? data.paginatedItems : null;
    setPaginatedData(paginatedItems);
    document.getElementsByClassName('main-container')[0].scrollTop = 0;
  };

  const flightTypeLabel = (flightTypeCode) => {
    if (flightTypeCode === FLIGHT_TYPE_CODES.ONE_WAY) {
      return renderContent(
        Dictionary.airFlightTypeOneWay.key,
        Dictionary.airFlightTypeOneWay.defaultValue,
      );
    }
    return renderContent(
      Dictionary.airFlightTypeRoundtrip.key,
      Dictionary.airFlightTypeRoundtrip.defaultValue,
    );
  };

  return (
    <>
      {paginatedData &&
        paginatedData.map((flight, index) => (
          <Card elevation={1} className={classes.resultCardWrapper} key={flight.routeId}>
            <CardContent
              className={classes.resultCard}
              onClick={() => {
                handleExpandClick(index);
              }}>
              <FlightInformation
                flight={flight}
                expanded={expanded}
                index={index}
                flightType={flightType}
              />
              <div className={clsx(classes.pricingInfo, classes.cardInfo)}>
                <div className={classes.flightPricing}>
                  <p className={clsx(classes.flightPrice, classes.standardLabel)}>
                    {`${formatPrice(
                      flight.lowestAvailableFare.value,
                      flight.lowestAvailableFare.currency,
                      true,
                      true,
                      false,
                    )} ${isSm ? '' : flight.lowestAvailableFare.currency}`}
                  </p>
                  <p className={clsx(classes.flightPriceUnit, classes.smallLabel)}>
                    {`${
                      isSm
                        ? flight.lowestAvailableFare.currency
                        : flightTypeLabel(flight.routeType.code)
                    }/${renderContent(
                      Dictionary.airPersonLabel.key,
                      Dictionary.airPersonLabel.defaultValue,
                    )}`}
                  </p>
                  {isSm && (
                    <p className={clsx(classes.smallLabel, classes.flightPriceUnit)}>
                      {flightTypeLabel(flight.routeType.code)}
                    </p>
                  )}
                  {flight.details[0].wasPricePerPassenger &&
                    flight.details[0].wasPricePerPassenger.value !== null && (
                      <p className={classes.flightWasPrice}>
                        {renderContent(
                          Dictionary.airFlightWasLabel.key,
                          Dictionary.airFlightWasLabel.defaultValue,
                        )}{' '}
                        {`${formatPrice(
                          Math.ceil(flight.details[0].wasPricePerPassenger.value),
                          flight.details[0].wasPricePerPassenger.currency,
                          true,
                          true,
                          true,
                        )}`}
                      </p>
                    )}
                </div>
                <ExpandMoreIcon
                  className={clsx(classes.expandFlightDetails, classes.expand, {
                    [classes.expandOpen]: expanded[index],
                  })}
                />
              </div>
            </CardContent>
            <FlightExpanded
              flight={flight}
              expanded={expanded}
              index={index}
              flightType={flightType}
            />
          </Card>
        ))}
      <Pagination
        items={filteredResults}
        className={classes.overridePagination}
        onChangePage={onChangePage}
        itemsPerPage={10}
      />
    </>
  );
};

export default ResultsCard;
